export const GAME_STATUS = {
  open: 0,
  locked: 1,
  limbo: 2,
  complete: 3,
  expired: 4,
}

export const SIDE_HEADS = 0
export const SIDE_TAILS = 1

export const MIN_FLIPS = 2
export const MAX_FLIPS = 5

export const COIN_PICKLES_SALTWATER = {
  id: 'pickles-saltwater',
  name: 'page.coinflip.coins.pickles_saltwater',
  [SIDE_HEADS]: {
    image: '/img/games/coinflip/pickles-saltwater-0.png',
    name: 'page.coinflip.coins.pickles_saltwater.heads',
    colorText: '#ddf2b8',
    colorBg: '#44591f',
    colorBorder: '#60A70F',
  },
  [SIDE_TAILS]: {
    image: '/img/games/coinflip/pickles-saltwater-1.png',
    name: 'page.coinflip.coins.pickles_saltwater.tails',
    colorText: '#b2d6ef',
    colorBg: '#193d56',
    colorBorder: '#0F87A7',
  },
}

export const COIN_PICKAXE_HATCHET = {
  id: 'pickaxe-hatchet',
  name: 'page.coinflip.coins.pickaxe_hatchet',
  [SIDE_HEADS]: {
    image: '/img/games/coinflip/pickaxe-hatchet-0.png',
    name: 'page.coinflip.coins.pickaxe_hatchet.heads',
    colorText: '#959595',
    colorBg: '#393939',
    colorBorder: '#959595',
  },
  [SIDE_TAILS]: {
    image: '/img/games/coinflip/pickaxe-hatchet-1.png',
    name: 'page.coinflip.coins.pickaxe_hatchet.tails',
    colorText: '#B76100',
    colorBg: '#412106',
    colorBorder: '#B76100',
  },
}

export const COIN_POOKIEBEAR_WOLFSKULL = {
  id: 'pookiebear-wolfskull',
  name: 'page.coinflip.coins.pookiebear_wolfskull',
  [SIDE_HEADS]: {
    image: '/img/games/coinflip/pookiebear-wolfskull-0.png',
    name: 'page.coinflip.coins.pookiebear_wolfskull.heads',
    colorText: '#D2BE3D',
    colorBg: '#4A3703',
    colorBorder: '#D2BE3D',
  },
  [SIDE_TAILS]: {
    image: '/img/games/coinflip/pookiebear-wolfskull-1.png',
    name: 'page.coinflip.coins.pookiebear_wolfskull.tails',
    colorText: '#CD412B',
    colorBg: '#2D0A04',
    colorBorder: '#CD412B',
  },
}

export const COINS = [
  COIN_PICKLES_SALTWATER,
  COIN_PICKAXE_HATCHET,
  COIN_POOKIEBEAR_WOLFSKULL,
]
